import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "text-end text-h5" }

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import {computed, ref, reactive, watch, inject} from 'vue';
import rules from '@/app/shared/domain/data/rules';
import BillingRepository from '@/app/billing/infrastructure/persistence/BillingRepository';
import InputMoney from '@/app/shared/components/inputs/InputMoney.vue';
import InputProjects from '@/app/shared/components/inputs/InputProjects.vue';
import Money from '@/app/shared/domain/classes/money';
import { useForm } from '@/app/shared/ui/composable/form';
import InputClients from '@/app/shared/components/inputs/InputClients.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const form = ref(null);

const repository = inject('billingRepository') as BillingRepository;

let billing = reactive({
    project_id: null,
    client_id: null,
    total: 0,
    items: [{
        description: '',
        value: '',
    }],
});

const projectsFilters = computed(() => {
    if (!billing.client_id) {
        return null;
    }

    return {
        client_id: billing.client_id,
    };
});

const { pageTitle, submit } = useForm(
    props,
    billing,
    repository,
    form,
    'Editar fatura',
    'Gerar fatura',
    '/faturas',
    '/faturas',
);

watch(billing, () => {
    billing.total = billing.items.reduce((sum, current) => {
        return sum + Number(current.value);
    }, 0);
});

const billingTotal = computed(() => new Money(billing.total).toStringBR());

const addItem = () => {
    billing.items.push({
        description: '',
        value: '',
    });
};

const removeItem = (index: number) => {
    if (billing.items.length > 1) {
        billing.items = billing.items.filter((item, i) => i !== index);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(submit),
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_text_field, {
                                  label: "Vencimento",
                                  rules: [_unref(rules).required, _unref(rules).date],
                                  modelValue: _unref(billing).due_date,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(billing).due_date) = $event))
                                }, null, 8, ["rules", "modelValue"]), [
                                  [_directive_mask, '##/##/####']
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(InputClients, {
                                  rules: [_unref(rules).required],
                                  modelValue: _unref(billing).client_id,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(billing).client_id) = $event))
                                }, null, 8, ["rules", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(InputProjects, {
                                  modelValue: _unref(billing).project_id,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(billing).project_id) = $event)),
                                  filters: _unref(projectsFilters)
                                }, null, 8, ["modelValue", "filters"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(billing).items, (item, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "9",
                                  class: "d-flex"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: ($event: any) => (removeItem(index)),
                                      icon: "",
                                      size: "x-small",
                                      class: "mr-3 mt-4",
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi:mdi-delete")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_v_text_field, {
                                      label: "Descrição",
                                      rules: [_unref(rules).required],
                                      modelValue: item.description,
                                      "onUpdate:modelValue": ($event: any) => ((item.description) = $event)
                                    }, null, 8, ["rules", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(InputMoney, {
                                      label: "Valor unitário",
                                      rules: [_unref(rules).required],
                                      modelValue: item.value,
                                      "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                    }, null, 8, ["rules", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_divider)
                              ], 64))
                            }), 128)),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: addItem,
                                  "prepend-icon": "mdi:mdi-plus",
                                  size: "x-small",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Adicionar item")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_2, "Total: " + _toDisplayString(_unref(billingTotal)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})